import { CollaboratorsInvitationModel } from "app/modules/wizard/models/collaborators-invitation.model";

export const WIZARD_V2_ACTION_PREFIX = '[Wizard V2 State]';

export class LoadJobFileAction {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Load JobFile`;
  constructor(public jobRefId: string) { }
}

export class UploadWizardAttachments {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} upload wizard documents`;
  constructor(public files: File[], public path: string) {}
}

export class RemoveWizardAttachment {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} remove wizard documents`;
  constructor(public attachmentId: string) {}
}

export class ResetWizardV2State {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Reset wizard v2 state`;
}

export class DeleteShipmentOrderJobFile {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Delete shipment order spec from jobfile`;
  constructor(public shipmentOrderId: string, public deleteFromOrderManager: boolean = false) { }
}

export class DeleteAllShipmentOrdersJobFile {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Delete all shipment order specs from jobfile`;
  constructor(public deleteFromOrderManager: boolean = false) { }
}

export class PatchShipmentOrderSpecsAction {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Patch shipment order specs`;
  constructor(public shipmentOrderSpecs: any[]) {}
}

export class InviteCollaborators {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Invite collaborators`;
  constructor(public collaboratorsInvitationModel: CollaboratorsInvitationModel) {}
}

export class RemoveCollaborator {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Remove collaborator`;
  constructor(public collaboratorId: string) {}
}

export class SetRouteOptions {
  static readonly type = `${WIZARD_V2_ACTION_PREFIX} Set Route Options`;
  constructor(public routeOptions: {
    useTimeWindows?: boolean;
    avoidTolls?: boolean;
    useMaxLocationCount?: boolean;
    noOfLocations?: number;
    supplierDeliveryStartDateTime?: Date | null;
    supplierDeliveryEndDateTime?: Date | null;
  }) {}
}
